import { type ClassActivityCategory, classActivityColors } from "../constants/ClassActivityConstants";
import IconTextRow from "./iconTextRow/IconTextRow";

interface FormInfoRowProps {
    children: string;
    // Renders the row as a mild warning (alert icon) tinted in the category's popup color.
    warningCategory?: ClassActivityCategory;
}

// role="status" so informational notices that appear dynamically are announced by screen readers.
const FormInfoRow = (props: FormInfoRowProps) => {
    const colorClass = props.warningCategory ? classActivityColors[props.warningCategory].text : "text-p6-grey-dark";

    return (
        <IconTextRow
            icon={props.warningCategory ? "alert" : "info"}
            text={props.children}
            iconClassName={`text-xxl ${colorClass}`}
            textClassName={`text-l ${colorClass}`}
            role="status"
        />
    );
};

export default FormInfoRow;
